import axios from 'axios'

export default {
	getTests (params = {}) {
		return axios.get('/api/test', {
			params: params
		})
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
	}
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/test.js